import React from 'react';
import { useDownloadProgrammation } from './useDownloadProgrammation';
import { ArrowDownCircleIcon as ArrowCircleDown } from '@heroicons/react/24/outline';
import Button from '@teetsh/app/src/components/Buttons/Button';
import {
  useProgrammationId,
  useProgrammationName,
} from '@teetsh/app/src/containers/Programmations/atoms/progAtoms';
import { useTranslation } from 'react-i18next';
import { DisplayConfig } from 'containers/Programmations/ProgV2/atoms';
import { PrintConfig } from 'containers/Programmations/ProgV2/Preview/types';
import { useFormState } from 'react-final-form';
import { ProgrammationPDFSettings } from 'types/programmations';
import { SidebarWithSections } from 'components/SubSidebar/SidebarWithSections';

interface Props {
  displayConfig: DisplayConfig;
  printConfig: PrintConfig;
  variant?: 'minimal' | 'collapsed';
  hideTitle: boolean;
}

function getProgrammationNameInIframe() {
  const iframe = document.getElementById('printFrame') as HTMLIFrameElement;
  if (iframe && iframe?.contentWindow) {
    // Get the document of the iframe
    const iframeDocument = iframe.contentWindow.document;

    // Get the programmation-title element
    const titleElement = iframeDocument.getElementById(
      'programmation-print-title',
    ) as HTMLElement;

    // Check if the element exists
    if (titleElement) {
      // Get the value of the element
      return titleElement.innerText;
    }
  }
  return undefined;
}

export function DownloadProgrammation(props: Props) {
  const { download, isDownloading } = useDownloadProgrammation();
  const { values: settings } = useFormState<ProgrammationPDFSettings>();
  const programmationName = useProgrammationName() || '';
  const programmationId = useProgrammationId();
  const { t } = useTranslation(['common']);

  const handleOnClick = () =>
    download({
      programmationName: getProgrammationNameInIframe() || programmationName,
      programmationId: programmationId as string,
      displayConfig: props.displayConfig,
      printConfig: props.printConfig,
      settings,
      hideTitle: props.hideTitle,
    });

  if (props.variant === 'minimal') {
    return (
      <Button
        minimal
        title={t('common:buttons.downloadPdf')}
        onClick={handleOnClick}
        icon={ArrowCircleDown}
      />
    );
  }

  if (props.variant === 'collapsed') {
    return (
      <SidebarWithSections.CollapsedButton
        icon={ArrowCircleDown}
        title={t('common:buttons.downloadPdf')}
        loading={isDownloading}
        onClick={handleOnClick}
      />
    );
  }

  return (
    <Button
      fill
      large
      intent="primary"
      loading={isDownloading}
      onClick={handleOnClick}
      icon={ArrowCircleDown}
    >
      {t('common:buttons.downloadPdf')}
    </Button>
  );
}
